import { Selector } from '@/components/selector';

import { AGENT_STATUS } from '@/constants';

import { type AgentStatusValue, useAgentsListStore } from '@/store/agents-list.store';

export const AgentStatusFilter = () => {
  const { filters, setFilter } = useAgentsListStore();

  return (
    <Selector
      options={[{ value: 'All', label: 'All' }, ...AGENT_STATUS]}
      value={filters.status}
      onChange={value => setFilter('status', value as AgentStatusValue)}
    />
  );
};
